import { useCallback } from 'react';
import { useIntl } from 'react-intl-next';

import type { FlagsStateContainer } from '@confluence/flags';

export const useHandleCollabError = (flags: FlagsStateContainer) => {
	const { formatMessage } = useIntl();

	return useCallback(() => {
		void flags.showErrorFlag({
			title: formatMessage({ id: 'collab.status.error' }),
			description: formatMessage({
				id: 'collab.status.tooltip.error',
			}),
		});
	}, [flags, formatMessage]);
};
